import { BaseTextAreaPropsType } from '@/common/components/base/textarea/base/CommonInput.type';
import textarea from '@/common/components/base/textarea/base/textarea.recipe';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { css, cx } from 'styled-system/css';
import { Box, Center, styled } from 'styled-system/jsx';

const Textarea = ({
  inputProps,
  errorMessage,
  label,
  inputRef,
  startAttachments,
  endAttachments,
  direction = 'rtl',
  placeholderAlign = 'start',
  hasErrorMassage = true,
  hasLabel = true,
}: BaseTextAreaPropsType) => {
  const startAttachment = startAttachments?.find((item) => item.shouldRender);
  const endAttachment = endAttachments?.find((item) => item.shouldRender);
  const { className } = inputProps;
  const attachmentInputStyles = css.raw({
    textAlign: {
      base: 'start',
      _placeholder: placeholderAlign === 'start' ? 'start' : 'end',
    },
  });
  const inputVariants = textarea({
    isError: !!errorMessage,
    endAttachment: endAttachment?.size,
    startAttachment: startAttachment?.size,
  });
  return (
    <Box>
      {hasLabel ? (
        <Typography height="24px" textStyle="b2">
          {label}
        </Typography>
      ) : null}
      <Box dir={direction} position="relative">
        {startAttachment ? (
          <Center className={inputVariants.startAttachment}>
            {startAttachment.element}
          </Center>
        ) : null}
        <styled.textarea
          ref={inputRef}
          {...attachmentInputStyles}
          {...inputProps}
          className={cx(inputVariants.root, className)}
        />

        {endAttachment ? (
          <Center className={inputVariants.endAttachment}>
            {endAttachment.element}
          </Center>
        ) : null}
      </Box>
      {hasErrorMassage ? (
        <Typography height="24px" color="red-1" textStyle="b4">
          {errorMessage}
        </Typography>
      ) : null}
    </Box>
  );
};
export default Textarea;
